import { render, staticRenderFns } from "./BedTagsModal.vue?vue&type=template&id=4e81a1ad&"
import script from "./BedTagsModal.vue?vue&type=script&lang=js&"
export * from "./BedTagsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports